import '../shared/sentry/init'

import ReactDOM from 'react-dom'

import { isIpad } from '../shared/isMobile'
import { ready } from '../shared/ready'
import ScamNotice from './scam-notice'
import Search, { SearchProps } from './search'
import Settings from './settings-dropdown'
import { Time } from './time'

/**
 * The script below allows iPads in landscape mode to size the page naturally
 * instead of forcing 1024px viewport which results in a zoomed in view
 */
if (isIpad()) {
  const minViewport = 1024
  const viewportString = { fixed: `width=${minViewport}`, fluid: 'width=device-width, initial-scale=1.0' }

  const getViewportWidth = () => Math.round(window.innerWidth * (window.visualViewport?.scale || 1))
  const setViewport = (fixedViewport: boolean) =>
    document
      .querySelector('meta[name=viewport]')
      ?.setAttribute('content', fixedViewport ? viewportString.fixed : viewportString.fluid)

  let viewportWidth = getViewportWidth()

  setViewport(viewportWidth <= minViewport)

  window.addEventListener('resize', function () {
    const newViewportWidth = getViewportWidth()
    // iOS fires resize on overscroll
    if (viewportWidth === newViewportWidth) return
    viewportWidth = newViewportWidth
    setViewport(newViewportWidth <= minViewport)
  })
}

function renderAccountDropdown(element: Element | null) {
  if (!element) return

  ReactDOM.render(<Settings />, element)
}

/**
 * Display scam notice when language matches 'ru' or 'et'
 */
function renderScamNotice(element: Element | null) {
  const languages = navigator.languages instanceof Array ? navigator.languages : [navigator.language]
  const targetLanguages = ['ru', 'et']
  const isTargetLanguage = languages
    .map((language) => language.toLowerCase())
    .some((language) => targetLanguages.some((targetLanguage) => language.includes(targetLanguage)))

  if (!element || !isTargetLanguage) return

  ReactDOM.render(<ScamNotice />, element)
}

function renderSearch(props?: SearchProps, retries = 0) {
  const container = document.getElementById('search')

  if (container) {
    ReactDOM.render(<Search {...props} />, container)
  } else if (retries < 10) {
    setTimeout(() => renderSearch(props, retries + 1), 300)
  }
}

ready(function () {
  renderSearch()
  const timeContainer = document.getElementById('time')
  if (timeContainer) ReactDOM.render(<Time className="w-full text-[11px] text-white" />, timeContainer)

  renderAccountDropdown(document.getElementById('account-dropdown'))
  renderScamNotice(document.getElementById('scam-notice'))
})

window['SearchFocus'] = function () {
  renderSearch({ focus: true })
}
